import { useState } from "react";
import styles from "./FilterGroup.module.css";
import { FilterButton } from "./FilterButton";

export const FilterGroup = ({
  leftSideFilters,
  rightSideFilters,
  defaultFilterName = "",
}) => {
  const [gridFilter, setGridFilter] = useState(defaultFilterName);

  return (
    <div className={styles.gridFiltersContainer}>
      <div>
        {leftSideFilters?.map((filter, index) => {
          return (
            <FilterButton
              key={index}
              currentFilterName={gridFilter}
              filterName={filter.name}
              btnText={filter.btnText}
              iconCss={filter?.iconCss}
              onClick={() => {
                setGridFilter(filter.name);
                filter.onClick();
              }}
            />
          );
        })}
      </div>
      <div>
        {rightSideFilters?.map((filter, index) => {
          return (
            <FilterButton
              key={index}
              currentFilterName={gridFilter}
              filterName={filter.name}
              btnText={filter.btnText}
              iconCss={filter?.iconCss}
              onClick={() => {
                setGridFilter(filter.name);
                filter.onClick();
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
